module.exports = __webpack_public_path__ + "static/media/monster-truck-driving.339e027a.jpg";